import { render } from "./TrxExchange.vue?vue&type=template&id=211ffcc4&scoped=true"
import script from "./TrxExchange.vue?vue&type=script&lang=js"
export * from "./TrxExchange.vue?vue&type=script&lang=js"

import "./TrxExchange.vue?vue&type=style&index=0&id=211ffcc4&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-211ffcc4"]])

export default __exports__